import { apiFuns } from "sw-hic";
let { genStandard } = apiFuns;
let api = {
  Apply: {
    ...genStandard("apply", "/api/md"),
  }
};
export default api;
